import React, { useContext } from 'react';
import {
  AccountService,
  SaveService,
  StoreIdCookieInformationService,
  ZipCodeCookieInformationService
} from '@inter-ikea-kompis/services';
import { useServiceSettings } from '../serviceSettings';
import {
  createAccountService,
  createSaveService,
  createStoreIdCookieInformationService,
  createZipCodeService
} from './utils';

type ServicesContextValue = {
  accountService: () => AccountService;
  saveService: SaveService;
  zipCodeService: ZipCodeCookieInformationService;
  storeService: StoreIdCookieInformationService;
};

export const ServicesContext = React.createContext<ServicesContextValue>({
  accountService: () => ({} as AccountService),
  saveService: {} as SaveService,
  zipCodeService: {} as ZipCodeCookieInformationService,
  storeService: {} as StoreIdCookieInformationService
});

export const useServices = () => useContext(ServicesContext);

export const ServicesProvider = ({ children }: { children: React.ReactNode }) => {
  const {
    dexfSettings,
    kompisSettings: { filterSegment }
  } = useServiceSettings();

  const accountService = () => createAccountService(dexfSettings, filterSegment);
  const saveService = createSaveService(dexfSettings, filterSegment);
  const zipCodeService = createZipCodeService(dexfSettings);
  const storeService = createStoreIdCookieInformationService(dexfSettings);

  return (
    <ServicesContext.Provider value={{ accountService, saveService, zipCodeService, storeService }}>
      {children}
    </ServicesContext.Provider>
  );
};
